import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ContentUtil } from '../../utils/content/content.util';
import { Sort, SortDirection } from '../../utils/sort/sort.interfaces';
import { TableColumn } from './table.interface';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { AscDescLabelPipe } from '../../pipes/asc-desc-label/asc-desc-label.pipe';
import { PendingChipComponent } from '../pending-chip/pending-chip.component';
import { CustomCellDirective } from '../../directives/custom-cell.directive';

@Component({
    selector: 'zci-table',
    templateUrl: './table.component.html',
    imports: [
        NgClass,
        NgFor,
        NgIf,
        AscDescLabelPipe,
        PendingChipComponent,
        CustomCellDirective
    ],
})
export class TableComponent {
    content = ContentUtil.content;

    @Input() tableColDef: TableColumn[] = [];

    @Input() tableData: { [key: string]: any }[] = [];

    @Input() ariaLabelledby: string = '';

    @Input() dataCy: string = 'zci-table';

    @Input() sortable: boolean = false;

    @Output() sort: EventEmitter<Sort> = new EventEmitter<Sort>();

    sortDirection = SortDirection;

    currentSortedColumn: Sort = {
        dataKey: null,
        sortDir: null,
    };

    sortColumn(dataKey: string) {
        const newSortDir =
            this.currentSortedColumn.sortDir === SortDirection.ASC
                ? SortDirection.DESC
                : SortDirection.ASC;

        const newSortedColumn: Sort = {
            dataKey,
            sortDir: newSortDir,
        };

        this.sort.emit(newSortedColumn);

        this.currentSortedColumn = newSortedColumn;
    }
}
